import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateProduct, UpdateProductPayload } from '../api/updateProduct';

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, id, image }: UpdateProductPayload) => {
      return await updateProduct({ name, id, image });
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['product', variables.id] }),
        queryClient.invalidateQueries({ queryKey: ['products-all'] })
      ]);
    }
  });
};
